import React from 'react';
import { ScanLine } from 'lucide-react';

/**
 * Compact Scanner Mode toggle for Bulk In/Out Scan.
 */
const ScannerModeToggle = ({ checked, onChange, disabled = false }) => (
  <div className="mb-6 inline-flex">
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label="Scanner Mode"
      disabled={disabled}
      title={
        checked
          ? 'Scanner Mode on — space added after each entry'
          : 'Scanner Mode off — use dots between vouchers'
      }
      onClick={() => {
        if (disabled) return;
        onChange(!checked);
      }}
      className={`inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-left transition-colors focus:outline-none focus:ring-2 focus:ring-[#46955A]/40 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 ${
        checked
          ? 'border-[#46955A]/40 bg-[#46955A]/10 text-[#2f6b3d]'
          : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50'
      }`}
    >
      <ScanLine className={`h-4 w-4 shrink-0 ${checked ? 'text-[#46955A]' : 'text-gray-500'}`} />
      <span className="text-sm font-medium whitespace-nowrap">Scanner Mode</span>
      <span
        className={`relative ml-1 inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors ${
          checked ? 'bg-[#46955A]' : 'bg-gray-300'
        }`}
      >
        <span
          className="inline-block h-3.5 w-3.5 rounded-full bg-white shadow transition-transform"
          style={{ transform: checked ? 'translateX(1.125rem)' : 'translateX(0.125rem)' }}
        />
      </span>
    </button>
  </div>
);

export default ScannerModeToggle;
